import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const HotelsStateActions = createActionGroup({
  source: "State/API",
  events: {
    "Save Hotel Filter Configuration": props<{ metadata: any }>(),
    "Load Hotels Filter Options": props<{ requestQuery: any }>(),
    "Load Hotels Filter Options Success": props<{
      data: { filterOptions: any };
    }>(),
    "Load Hotels Filter Options Failure": props<{ error: any }>(),
    "Load Hotels Data": props<{ requestQuery: any }>(),
    "Load Hotels Data Success": props<{
      data: { hotels: any; totalRecordsLeft: number, totalRecords: number };
    }>(),
    "Load Hotels Data Failure": props<{ error: any }>(),
    "Load More Hotels Data": props<{ requestQuery: any }>(),
    "Load More Hotels Data Success": props<{
      data: { hotels: any; totalRecordsLeft: number };
    }>(),
    "Load More Hotels Data Failure": props<{ error: any }>(),
    // 'Load States': props<{ states: State[] }>(),
    // 'Add State': props<{ state: State }>(),
    // 'Upsert State': props<{ state: State }>(),
    // 'Add States': props<{ state: State[] }>(),
    // 'Upsert States': props<{ state: State[] }>(),
    // 'Update State': props<{ state: Update<State> }>(),
    // 'Update States': props<{ states: Update<State>[] }>(),
    // 'Delete State': props<{ id: string }>(),
    // 'Delete States': props<{ ids: string[] }>(),
    'Set Quick Filter': props<{ selectedQuickFilter: string }>(),
  },
});
